module.exports = __webpack_public_path__ + "media/images/let-you-screen/logo-2c3af99b95497e203c04be93d1ed9a08.svg";